import { Box, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';

interface ErrorBoundaryProps {
  icon?: React.ReactNode;
  message: string;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ icon, message }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        padding: '16px',
      }}
    >
      {icon ?? <ErrorIcon />}

      <Typography variant="h3" component="p">
        {message}
      </Typography>
    </Box>
  );
};

export default ErrorBoundary;
